module.exports = __webpack_public_path__ + "img/project4_6.jpg.411ca284.webp";